// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios';
import router from './router'
import animate from 'wowjs/css/libs/animate.css';

Vue.config.productionTip = false

import api from './api/newApi'
import './utils/flexible'
// css
import './assets/css/index.css'
import './assets/font/font.css'; 


Vue.prototype.$http = axios;
// 图片服务器地址
Vue.prototype.imgserver = 'http://cm.qingting1.com:22122/'
// Vue.prototype.imgserver = 'http://dev.qingting1.com:8080/file-server/' 
Vue.prototype.imgProserver = 'http://cm.qingting1.com:22122/'
Object.defineProperty(Vue.prototype, '$api', { value: api})

Vue.use(animate);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js